import { reportLevelOneNavigationSelectors as selector } from "../Selectors/index";

export const reportLevelOneNavigationReducer = (
  state = [],
  { type, payload }
) => {
  switch (type) {
    case selector.GET_REPORT_LEVEL_ONE_ROLE_SUCCESS:
      // console.log("Setting Report Level One Navigation in Redux state:", payload);
      return payload;

    default:
      return state;
  }
};